import { Injectable } from '@angular/core';
import { HttpClient,HttpParams, HttpHeaders} from '@angular/common/http';
import { GlobalVariable } from 'app/main/globals';

@Injectable({
  providedIn: 'root'
})
export class AspCustomerQuoteService {

  constructor(private http: HttpClient) { }
 
  getQuoteDetails(garageKey,quoteId,userKey,jobCardId,bookingId){
    let param={
      garageKey:garageKey,
      quoteId: quoteId,
      userKey:userKey,
      jobCardId : jobCardId,
      source: "web",
      bookingId: bookingId,
      // jobcardId:jobCardId,
    }
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/garage/customer/quote/detail`,param)
  }
  submitData(payload: any) {
    const paramData=payload;
    console.log("paramData",JSON.stringify(paramData))
    return this.http.post(`${GlobalVariable. BASE_API_URL_SPARES}/garage/customer/quote/create`, paramData);
}
requestDetails(garageKey, requestId, userKey){
  let paramData = {      
    garageKey: garageKey,
    requestId: requestId,
    userKey: userKey,
    source: "web" 
    
  };

  return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}` + '/spare/request/details', paramData);
}

submitDataUpdate(payload: any){
  const paramData=payload;
  
  console.log('-----submitDataUpdate-----------');    
  return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/garage/customer/quote/update`, paramData);

}
createNewItem(payload: any){
  const paramData=payload;
  
  console.log('-----addItem-----------');    
  return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/garage/v1/add-spares`, paramData);

}

markAsComplete(payload: any){
  payload.source = 'web';
  return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/garage/quoteItemsStatus`,payload);
}



getJobCardDetails(bookingId: number, garageKey: string, jobCardId: number) {
  const paramData = {
    bookingId,
    garageKey,
    jobCardId,
    source: "web"
  };
  console.log("PARAM DATA OF JOBCARD DETAILS---",paramData)
  return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}` + '/booking/v1/jobCard/detail', paramData);
}
  searchB2BLineItem(searchTerm: string) {
    const spareGarageId = localStorage.getItem('spareGarageId');
  
    const sessionPost = {
      spareGarageId: spareGarageId,
      userType: 'pitstopspare',
      search: searchTerm,
      type: ''
    };
  
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
  
    const body = new HttpParams()
      .set('sessionPost', JSON.stringify(sessionPost));
  
    return this.http.post(`${GlobalVariable.BASE_API_URL}/pitstop/b2bsearchlineitem`, body, { headers });
  }
}
